import { useState } from "react";
import styles from "../styles/ContactForm.module.css";

import Button from "./Button";

export default function ContactForm() {
  function onChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "note-ninja",
    message: "",
  });
  const onSubmit = (e) => {
    e.preventDefault();
    console.log("jej");
  };
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <article className="card">
          <form className={styles.form} onSubmit={onSubmit}>
            <h2 className={styles.title}>Contact Form</h2>

            <div className={styles.grid2}>
              <div className={styles.field}>
                <label className={styles.label} htmlFor="name">
                  Name
                </label>
                <input
                  id="name"
                  name="name"
                  className={styles.input}
                  value={form.name}
                  onChange={onChange}
                  autoComplete="name"
                />
              </div>

              <div className={styles.field}>
                <label className={styles.label} htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className={styles.input}
                  value={form.email}
                  onChange={onChange}
                  autoComplete="email"
                />
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label} htmlFor="subject">
                Subject
              </label>
              <div className={styles.selectWrap}>
                <select
                  id="subject"
                  name="subject"
                  className={styles.select}
                  value={form.subject}
                  onChange={onChange}
                >
                  <option value="note-ninja">Note Ninja support</option>
                  <option value="record-health">Record Health support</option>
                  <option value="collaboration">Collaboration</option>
                  <option value="other">Other</option>
                </select>

                <span className={styles.chevron} aria-hidden="true">
                  ▾
                </span>
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label} htmlFor="message">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                className={styles.textarea}
                value={form.message}
                onChange={onChange}
                rows={6}
              />
              <p className={styles.helper}>
                I’ll only use your message details to respond.
              </p>
            </div>

            <Button size="btnFull">Send message</Button>

            <p className={styles.note}>
              No spam — I only use your info to reply.
            </p>
          </form>
        </article>
      </div>
    </section>
  );
}
